import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from '../../services';
import { Button, Link, Paper, Stack } from '@mui/material';
import { useCallback } from 'react';
import styles from './StudyRequest.module.css';

interface Props {
  requestId: string | null,
  onReset: () => void,
}

const StudyRequestConfirm = ({requestId, onReset}: Props) => {
	const { t } = useTranslation();
  const isSmBreakpoint = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  const copyRequestId = useCallback(async () => {
		try {
			requestId && (await navigator.clipboard.writeText(requestId));
			console.log('The requestID was copied to clipboard successfully.');
		} catch (e) {
			console.error(e);
		}
	}, [requestId]);

  return (
    <Paper elevation={2} className={styles.background}>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ height: '50vh' }}
      >
        {t('Study request accepted')}
        {isSmBreakpoint && <p style={{marginBottom: 0}}>{t('Yor request id:')}</p>}
        <p style={{...(isSmBreakpoint ? {marginTop: 0} : {})}}>
          {!isSmBreakpoint && t('Yor request id:')}
          <Button
            onClick={copyRequestId}
            title={t('Copy')}
            type="button"
          >
            {requestId} &nbsp; <ContentCopyIcon />
          </Button>
        </p>
        <Link style={{fontSize: '16px'}} component="button" onClick={onReset}>{t('Create new study request')}</Link>
      </Stack>
    </Paper>
  );
}

export default StudyRequestConfirm;